import React from "react";
import styled from "styled-components";

interface CustomToggleProps {
  toggleItem: boolean;
  toggleFirstTitle?: string;
  toggleSecondTitle?: string;
  onChange: any;
  activeColor?: string;
}

const CustomToggle: React.FC<CustomToggleProps> = ({
  toggleItem,
  toggleFirstTitle,
  toggleSecondTitle,
  onChange,
  activeColor,
}) => {
  return (
    <Style>
      <div
        className="viewType"
        style={{
          background: toggleItem
            ? activeColor
              ? activeColor
              : "#000000"
            : "#d9d9d9",
        }}
        onClick={() => onChange(!toggleItem)}
      >
        <div
          className={`toggleButton ${!toggleItem && "active"} ${
            !toggleFirstTitle && "noTitle"
          }`}
          style={{
            background: !toggleItem
              ? "#ffffff"
              : activeColor
              ? activeColor
              : "#000000",
          }}
        >
          {toggleFirstTitle}
        </div>
        <div
          className={`toggleButton ${toggleItem && "active"} ${
            !toggleSecondTitle && "noTitle"
          }`}
          style={{ background: toggleItem ? "#ffffff" : "#d9d9d9" }}
        >
          {toggleSecondTitle}
        </div>
      </div>
    </Style>
  );
};

export default CustomToggle;

const Style = styled.div`
  .viewType {
    display: flex;
    align-items: center;
    width: min-content;
    border-radius: 50px;
    background: #d9d9d9;
    padding: 2px;
    white-space: nowrap;
    border: none;
    cursor: pointer;

    .toggleButton {
      width: 20px;
      padding: 2px 0;
      color: #adadad;
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      border-radius: 50px;
      background: #d9d9d9;
      border: none;
    }
    .toggleButton.noTitle {
      padding: 10px 0;
    }
    .toggleButton.active {
      background: #ffffff;
      color: #000000;
      border-radius: 50px;
    }
  }
`;
